import { render, staticRenderFns } from "./ContractTabsItems.vue?vue&type=template&id=368d6492&scoped=true"
import script from "./ContractTabsItems.vue?vue&type=script&lang=js"
export * from "./ContractTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d6492",
  null
  
)

export default component.exports